import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const Divider = styled.div`
  width: 1px;
  height: 16px;
  flex-shrink: 0;
  align-self: center;
  background-color: ${({ theme }) => theme.colors.grey24};
`

export const Follow = styled(Button)`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  ${({ isMenu }) => !isMenu && 'padding: 0;'}
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ addGap }) => addGap};
  color: ${({ theme }) => theme.grey84};
`
